/*
 * BITCO price-range slider.
 * The collection price facet shows a gradient dual-handle track
 * (.bitco-facets__price-track) that was purely decorative — the handles sat at
 * hardcoded percentages with no behaviour, so the slider "didn't work". This
 * wires the handles to the real <price-range> min/max inputs: dragging a handle
 * updates its input and, on release, dispatches an `input` event so Dawn's
 * FacetFiltersForm (which listens for `input` on the form) re-runs the filter.
 * The inputs remain the accessible control; this is a pointer enhancement.
 *
 * Re-initialises after each facet re-render (FacetFiltersForm replaces the
 * facets markup on every filter change) via a MutationObserver.
 */
(function () {
  // Parse a money_without_currency string (locale-aware: "1.234,50" or "1234.50").
  function parseNum(s) {
    if (s == null) return NaN;
    s = String(s).trim().replace(/\s/g, '');
    if (s === '') return NaN;
    if (s.indexOf(',') > -1 && s.indexOf('.') > -1) {
      // both present: dot = thousands, comma = decimal (EU)
      s = s.replace(/\./g, '').replace(',', '.');
    } else if (s.indexOf(',') > -1) {
      s = s.replace(',', '.');
    }
    var n = parseFloat(s);
    return isNaN(n) ? NaN : n;
  }

  function initSlider(track) {
    var container = track.closest('.facets__display-vertical') || track.parentElement;
    if (!container) return;
    var pr = container.querySelector('price-range');
    if (!pr) return;
    var inputs = pr.querySelectorAll('input');
    if (inputs.length < 2) return;
    var minInput = inputs[0];
    var maxInput = inputs[1];
    var rangeMax = parseNum(minInput.getAttribute('data-max'));
    if (isNaN(rangeMax)) rangeMax = parseNum(maxInput.getAttribute('data-max'));
    if (isNaN(rangeMax) || rangeMax <= 0) return;

    var fill = track.querySelector('.bitco-facets__price-track-fill');
    var hMin = track.querySelector('.bitco-facets__price-track-handle--min');
    var hMax = track.querySelector('.bitco-facets__price-track-handle--max');
    if (!fill || !hMin || !hMax) return;

    function curMin() {
      var v = parseNum(minInput.value);
      return isNaN(v) ? 0 : Math.max(0, Math.min(v, rangeMax));
    }
    function curMax() {
      var v = parseNum(maxInput.value);
      return isNaN(v) ? rangeMax : Math.max(0, Math.min(v, rangeMax));
    }
    function render() {
      var pMin = (curMin() / rangeMax) * 100;
      var pMax = (curMax() / rangeMax) * 100;
      hMin.style.left = pMin + '%';
      hMax.style.left = pMax + '%';
      fill.style.left = pMin + '%';
      fill.style.right = (100 - pMax) + '%';
    }
    render();

    // Keep the slider in sync when the shopper types in the inputs.
    minInput.addEventListener('input', render);
    maxInput.addEventListener('input', render);

    function bindHandle(handle, isMin) {
      handle.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        var rect = track.getBoundingClientRect();
        function move(ev) {
          var ratio = rect.width ? (ev.clientX - rect.left) / rect.width : 0;
          ratio = Math.max(0, Math.min(1, ratio));
          var val = Math.round(ratio * rangeMax);
          if (isMin) {
            var mx = curMax();
            if (val > mx) val = mx;
            minInput.value = val > 0 ? String(val) : '';
          } else {
            var mn = curMin();
            if (val < mn) val = mn;
            maxInput.value = val < rangeMax ? String(val) : '';
          }
          render();
        }
        function up() {
          document.removeEventListener('pointermove', move);
          document.removeEventListener('pointerup', up);
          handle.classList.remove('is-dragging');
          // Fire the filter (FacetFiltersForm debounces `input` on the form).
          (isMin ? minInput : maxInput).dispatchEvent(new Event('input', { bubbles: true }));
        }
        handle.classList.add('is-dragging');
        document.addEventListener('pointermove', move);
        document.addEventListener('pointerup', up);
      });
    }
    bindHandle(hMin, true);
    bindHandle(hMax, false);
  }

  function initAll(root) {
    (root || document).querySelectorAll('.bitco-facets__price-track').forEach(function (t) {
      if (t.dataset.priceSliderInit) return;
      t.dataset.priceSliderInit = '1';
      initSlider(t);
    });
  }

  function boot() {
    initAll();
    // Facets re-render on every filter change — re-init the fresh track markup.
    var scope = document.querySelector('.bitco-collection-layout') || document.body;
    if (!scope || !window.MutationObserver) return;
    var scheduled = false;
    var obs = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        initAll();
      });
    });
    obs.observe(scope, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
